import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import { Tons } from "../../../../../../domain/units/Tons";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";
import { eqeqeq } from "../../../../../../shared/utils/equality";

const fieldName = "Ballast Weight";

const BallastWeightFormItemProvider: FormItemProvider<Tons> = (props: FormItemProviderProps<Tons>) => (
  <GenericNumberFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="BallastWeight"
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new Tons(input)))}
    addonAfter="tons"
    allowNegative={false}
    separateThousands={true}
    integersOnly={false}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(BallastWeightFormItemProvider);